import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { hasPlanAccess } from '../utils/planAccess';

const PlanSpecificRoute = ({ children, requiredPlan, fallbackRoute = "/pricing" }) => {
  const { hasActiveSubscription, loading, user, isAuthenticated } = useAuth();

  // Add logging to track plan-specific access
  // console.log("🔐 PlanSpecificRoute render:", {
  //   loading,
  //   isAuthenticated,
  //   hasActiveSubscription,
  //   userEmail: user?.email,
  //   userPlan: user?.subscription_plan,
  //   requiredPlan,
  //   hasAccess: hasPlanAccess(user?.subscription_plan, requiredPlan)
  // });

  // Show loading spinner while checking authentication and subscription
  if (loading) {
    // console.log("⏳ PlanSpecificRoute: Loading state");
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-500"></div>
      </div>
    );
  }

  // First check: redirect to login if not authenticated
  if (!isAuthenticated) {
    // console.log("🚫 PlanSpecificRoute: Not authenticated, redirecting to login");
    return <Navigate to="/login" replace />;
  }

  // Second check: ensure user data exists
  if (!user) {
    // console.log("⚠️ PlanSpecificRoute: Authenticated but no user data, redirecting to login");
    return <Navigate to="/login" replace />;
  }

  // Third check: redirect to pricing page if no active subscription
  if (!hasActiveSubscription) {
    // console.log("🚫 PlanSpecificRoute: No active subscription, redirecting to pricing");
    return <Navigate to="/pricing" replace />;
  }

  // Fourth check: verify plan-specific access
  if (!hasPlanAccess(user.subscription_plan, requiredPlan)) {
    // console.log(`🚫 PlanSpecificRoute: Insufficient plan access. User has ${user.subscription_plan}, but ${requiredPlan} is required`);
    return <Navigate to={fallbackRoute} replace />;
  }

  // Render children if user has sufficient plan access
  // console.log(`✅ PlanSpecificRoute: Sufficient plan access (${user.subscription_plan} >= ${requiredPlan}), rendering protected content`);
  return children;
};

export default PlanSpecificRoute;
